import URL_FACTORY from '@/helpers/url-helper';
import CustomImageComponent from '../shared/custom/custom-image';
import { Box, Typography, useTheme } from '@mui/material';
import { getCompetitionImage } from '@/helpers/leagues-helper';
import { LEAGUES } from '@/constants/leagues';

const JugadoresConvocatoriaSeleccion = ({ player }) => {
    const theme = useTheme();
    const convocatoria = player?.cs;

    if (!convocatoria?.ic) {
        return null;
    }

    const countryCode = player?.cs?.cc;
    const countryName = player?.cs?.cn;

    return (
        <Box
            bgcolor={theme.palette.background.card}
            px={1}
            py={0.5}
            display={'flex'}
            borderRadius={0.5}
            width={'100%'}
            my={1}
        >
            <Typography sx={{ mr: 1 }}>Convocado:</Typography>
            {countryCode && (
                <>
                    <CustomImageComponent
                        src={URL_FACTORY.GetCountryImage(countryCode, 30)}
                        width={20}
                        height={20}
                        alt="selección"
                        style={{ borderRadius: '50%' }}
                    />
                    <Typography style={{ margin: 0, marginLeft: '4px' }}>{countryName}</Typography>
                </>
            )}
            {!countryCode && (
                <CustomImageComponent
                    src={getCompetitionImage(LEAGUES.FIFA_FRIENDLIES)}
                    width={20}
                    height={20}
                    alt="selección"
                    style={{ borderRadius: '50%' }}
                />
            )}
        </Box>
    );
};

export default JugadoresConvocatoriaSeleccion;
